import React from "react";
import "./App.scss";
import { PagesRoutes } from "./Routes";
import { Route, Routes } from "react-router-dom";
import AuthGuard from "./Components/AuthGuard/AuthGuard";
import {
  ThemeProvider,
  createTheme,
  responsiveFontSizes,
} from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

let theme = createTheme({
  palette: {
    primary: {
      main: "#2f519f",
    },
    secondary: {
      main: "#ff9800",
    },
    background: {
      default: "#f4f5f7", // Corrisponde a $bg-light-gray
      paper: "#ffffff", // Corrisponde a $bg-white
    },
    info: {
      main: "#757575", // <--- Grey color here
      contrastText: "#ffffff", // Ensures white text/icon when filled
    },
  },
  typography: {
    fontFamily: ["Roboto", '"Helvetica Neue"', "Arial", "sans-serif"].join(","),
  },
});

// Opzionale: Rende i caratteri adattivi alla dimensione dello schermo
theme = responsiveFontSizes(theme);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div>
        <Routes>
          {PagesRoutes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                element={
                  <AuthGuard
                    component={route.component}
                    requiresAuth={route.requiresAuth}
                  />
                }
              />
            );
          })}
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
